/* eslint-disable */
import type { LocalizableString } from "../cash/localization/localization.pb";
import type { Image } from "../cash/ui/Image.pb";
import type { ClientScenario } from "../franklin/api.pb";

export interface BankingTab {
  banking_tab_sections?: BankingTabBankingTabSection[];
  disclosure?: BankingTabDisclosure;
  balance_home_sections?: BankingTabBankingTabSection[];
  balance_home_disclosure?: BankingTabDisclosure;
}

export enum BankingTabAppearance {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface BankingTabClientScenarioAction {
  client_scenario?: ClientScenario;
}

export interface BankingTabClientRouteAction {
  url?: string;
}

export interface BankingTabDialog {
  title?: string;
  localizable_title?: LocalizableString;
  /** The message shown on the dialog. */
  main_text?: string;
  localizable_main_text?: LocalizableString;
  /** The primary button, shown on the right, or top if vertically stacked. */
  primary_button?: BankingTabDialogButton;
  /** The secondary button, shown on the left, or second if vertically stacked */
  secondary_button?: BankingTabDialogButton;
  /** This id will be used for metric collection on the client side */
  id?: string;
}

export interface BankingTabDialogButton {
  /** The text shown on the dialog button. */
  text?: string;
  localizable_text?: LocalizableString;
  client_scenario_action?: BankingTabClientScenarioAction | undefined;
  dismiss_action?:
    | BankingTabDialogButtonDismissAction
    | undefined;
  /** This id will be used for metric collection on the client side */
  id?: string;
}

export interface BankingTabDialogButtonDismissAction {
}

export interface BankingTabText {
  text?: string;
  localizable_text?: LocalizableString;
  alignment?: BankingTabTextAlignment;
}

export enum BankingTabTextAlignment {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  CENTER = "CENTER",
  JUSTIFIED = "JUSTIFIED",
}

export interface BankingTabUpsellOption {
  image?: Image;
  header?: BankingTabText;
  description?: BankingTabText;
  button?: BankingTabUpsellOptionButton;
}

export interface BankingTabUpsellOptionButton {
  button_text?: string;
  localizable_button_text?: LocalizableString;
  client_route_action?: BankingTabClientRouteAction;
}

/** Denotes a single banking option shown in the banking tab. */
export interface BankingTabBankingOption {
  id?: string;
  main_text?: string;
  localizable_main_text?: LocalizableString;
  secondary_text?: string;
  localizable_secondary_text?: LocalizableString;
  image?: Image;
  appearance?: BankingTabAppearance;
  client_scenario_action?: BankingTabClientScenarioAction | undefined;
  dialog?: BankingTabDialog | undefined;
  client_route_action?:
    | BankingTabClientRouteAction
    | undefined;
  /** The red dot on the far left used to signal call to action */
  is_badged?: boolean;
  /** The blue "New" pill on the far right used to signal an option the user hasn't seen before */
  has_new_pill?: boolean;
}

/** A short term approach for handling the Borrow button on the Banking tab. */
export interface BankingTabBorrowOption {
  id?: string;
}

/**
 * A short term approach for handling the Taxes button on the Banking tab.
 * The approach is due because Taxes doesn't support ClientScenario or ClientRoute for navigation within the app.
 */
export interface BankingTabTaxesOption {
  id?: string;
  main_text?: string;
  localizable_main_text?: LocalizableString;
  secondary_text?: string;
  localizable_secondary_text?: LocalizableString;
  image?: Image;
  appearance?: BankingTabAppearance;
  client_route_action?: BankingTabClientRouteAction;
  /** The red dot on the far left used to signal call to action */
  is_badged?: boolean;
}

export interface BankingTabOptions {
  banking_option?: BankingTabBankingOption;
  borrow_option?: BankingTabBorrowOption;
  upsell_option?: BankingTabUpsellOption;
  taxes_option?: BankingTabTaxesOption;
}

export interface BankingTabBankingTabSection {
  header_block?: BankingTabBankingTabSectionHeaderBlock;
  banking_options?: BankingTabOptions[];
}

export interface BankingTabBankingTabSectionHeaderBlock {
  heading?: string;
  localizable_heading?: LocalizableString;
}

export interface BankingTabDisclosure {
  text?: string;
  localizable_text?: LocalizableString;
}
